import { createElement } from "react";
import { Link as LinkIcon } from "lucide-react";
import {
  LinkCardParamsSchema,
  defaultLinkCardParams,
  type LinkCardParams,
} from "@playbookai/widget-schemas";
import type { WidgetBodyProps, WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { LinkCardWidget } from "../linkCard/Component.js";

function HoshinLinkTileWidget(props: WidgetBodyProps<LinkCardParams>) {
  return createElement(LinkCardWidget, { ...props, stagedEditing: true });
}

/** SQL definition reusing the existing Link card renderer and schema. */
export const linkTileDef: WidgetDef<LinkCardParams> = {
  kind: "linkTile",
  label: "Link card",
  modes: ["canvas"],
  singleton: false,
  // Includes the canvas drag bar + ModuleCard header/body padding and leaves
  // enough room for both editor inputs and the Save/Cancel action row.
  defaultSize: { w: 300, h: 280 },
  defaultParams: defaultLinkCardParams,
  Component: HoshinLinkTileWidget,
  storage: "sql",
  schema: LinkCardParamsSchema,
  accent: "purple",
  icon: LinkIcon,
  subtitle: "Document, dashboard, or runbook",
  defaultRoster: false,
  category: "multi",
  layout: { col: "full", row: 0, width: 300, height: 126 },
};

registerWidget(linkTileDef);
